export class NTManualAllocation {
  GetNTManualAPI: string = "";
  GetVendorEmailAPI: any;
  GetNTCapcityList: string = "";
  AllocatetoUser: any = "";
  GetVendorAllocatedArticleList: string = "";
  GetArticleListByBatchAPI: string = "";
  GetUserList: string = "";
  SendtoVendor: string = "";
  GetUploadBatchAPI: string = "";
  AutoAllocation: string = "";
  GetBioMedProductionReport: string = "";
}
